<div class="px-6 py-5 mx-auto max-w-5xl">

  <!-- Profile header -->
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-6 flex flex-col md:flex-row items-center gap-6 mb-6">
    <div class="relative">
      <input type="file" class="hidden" (change)="fileChangeEvent($event)" #inputFile accept="image/png, image/jpeg">
      @if(isImageLoaded) {
        <div class="cursor-pointer" (click)="showPhoto()">
          <app-avatar [name]="formProfile.get('usuario')?.value || ''" [photoUuid]="photoUuid" size="lg" />
        </div>
        <button (click)="inputFile.click()"
          class="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-vivid-royal-500 text-white flex items-center justify-center shadow-md hover:bg-vivid-royal-600 transition-colors cursor-pointer">
          <i class="pi pi-camera text-xs"></i>
        </button>
      } @else {
        <app-avatar [name]="formProfile.get('usuario')?.value || ''" size="lg" />
      }
    </div>
    <div>
      <h1 class="text-xl font-bold text-vivid-royal-800 dark:text-white">{{ formProfile.get('usuario')?.value }}</h1>
      <p class="text-sm text-vivid-royal-400">{{ formProfile.get('tipoAcceso')?.value }} · {{ formProfile.get('email')?.value }}</p>
      <span class="inline-block mt-1 px-2.5 py-0.5 rounded-full text-xs font-semibold"
        [ngClass]="formProfile.get('estado')?.value === 'Activo' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
        {{ formProfile.get('estado')?.value }}
      </span>
    </div>
  </div>

  <!-- Profile details -->
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-6">
    <h2 class="text-sm font-semibold text-mustard-700 dark:text-mustard-400 uppercase tracking-wide mb-4">Información de la cuenta</h2>
    <form [formGroup]="formProfile">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">No. de cliente</label>
          <input pInputText formControlName="noCliente" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Tipo de compra</label>
          <input pInputText formControlName="tipoCompra" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Dispositivos</label>
          <input pInputText formControlName="dispositivos" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">RFC</label>
          <input pInputText formControlName="rfc" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Teléfono</label>
          <input pInputText formControlName="telefono" class="w-full mt-1" />
        </div>
        <div>
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Correo electrónico</label>
          <input pInputText formControlName="email" class="w-full mt-1 lowercase" />
        </div>
        <div class="md:col-span-2">
          <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Dirección</label>
          <input pInputText formControlName="direccion" class="w-full mt-1" />
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Cropper dialog -->
<p-dialog header="Recortar imagen" [(visible)]="showCropper" [modal]="true" [style]="{width: '500px'}">
  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="1 / 1"
    format="png"
    output="base64"
    [autoCrop]="false"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded($event)"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"
    class="w-full"
    #cropperDiv
  ></image-cropper>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showCropper=false"></button>
    <button pButton label="Recortar" icon="pi pi-check" (click)="doCrop()"></button>
  </ng-template>
</p-dialog>

<!-- Photo preview dialog -->
<p-dialog header="Foto de perfil" [(visible)]="showProfileImage" [modal]="true" [style]="{width: '500px'}" [dismissableMask]="true"
  (onHide)="firstTime=true">
  <img class="w-full mx-auto rounded-lg" [src]="imageProfile" alt="Foto de perfil" />
</p-dialog>
